import { useFormikContext } from 'formik'

import Button from '../../../Button'
import { LOGIN_FORM_FIELD_HEIGHT } from '../Login.constants'

import * as styles from './LoginFormBodyActions.module.css'

function LoginFormBodyActions({
  LoginAsEmployeeButton,
  ResendCodeButton,
  isLoading,
  loginAsEmployeeButtonProps,
  resendCodeButtonProps,
  submitText,
}) {
  const { isSubmitting } = useFormikContext()

  return (
    <>
      <Button.Contained
        className={styles.submitButton}
        height={LOGIN_FORM_FIELD_HEIGHT}
        isLoading={isLoading ?? isSubmitting}
        text={submitText}
        type='submit'
      />
      {LoginAsEmployeeButton ? (
        <LoginAsEmployeeButton
          {...loginAsEmployeeButtonProps}
          className={styles.loginAsEmployeeButton}
          isLoading={isLoading}
        />
      ) : null}
      {ResendCodeButton ? (
        <ResendCodeButton
          {...resendCodeButtonProps}
          className={styles.resendCodeButton}
          isLoading={isLoading}
        />
      ) : null}
    </>
  )
}

export default LoginFormBodyActions
